import { IntegrationChannelType } from 'generated/graphql';

export const getIntegrationDataLabel = (
  channelType: IntegrationChannelType,
) => {
  switch (channelType) {
    case IntegrationChannelType.Slack:
    case IntegrationChannelType.Discord:
      return 'channels';
    case IntegrationChannelType.Discourse:
      return 'categories';
    case IntegrationChannelType.SurveyMonkey:
    case IntegrationChannelType.Qualtrics:
      return 'surveys';
    case IntegrationChannelType.Typeform:
      return 'forms';
    case IntegrationChannelType.Salesforce:
      return 'objects';
    case IntegrationChannelType.FacebookPages:
      return 'page';
    case IntegrationChannelType.FileUpload:
      return 'file';
    case IntegrationChannelType.Reddit:
      return 'subreddit';
    default:
      return '';
  }
};
